module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[108]595.1edbd27.woff2";